import { render, staticRenderFns } from "./AnswerColumns.vue?vue&type=template&id=ef5a16f6&scoped=true&"
import script from "./AnswerColumns.vue?vue&type=script&lang=js&"
export * from "./AnswerColumns.vue?vue&type=script&lang=js&"
import style0 from "./AnswerColumns.vue?vue&type=style&index=0&id=ef5a16f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef5a16f6",
  null
  
)

export default component.exports